import { useState, useEffect } from 'react';
import { NavLink, useLocation, matchPath, useNavigate } from 'react-router-dom';
import { FiLogOut, FiMenu, FiX } from 'react-icons/fi';
import { FaHistory } from "react-icons/fa";
import { RiRefund2Fill } from "react-icons/ri";
import { BsFillFuelPumpFill } from "react-icons/bs";
import { MdAccountBox, MdPayments, MdEventAvailable, MdCalendarToday } from "react-icons/md";
import { TbSettingsDollar } from "react-icons/tb";
import logo from '../assets/FareFuel_logo.png';

const TopBarWithSidebar = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(!isMobile);

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);
  const handleMobileClose = () => isMobile && setIsSidebarOpen(false);

  const location = useLocation();

  const navigate = useNavigate();

  const handleLogout = () => {
    sessionStorage.clear();
    navigate('/login');
  };


  // ✅ Updated to match pickup_id for both view & scan routes
  const isPickupHistoryActive =
    location.pathname === '/driverpickuphistory' ||
    matchPath({ path: '/driverpickuphistory/*' }, location.pathname) ||
    matchPath({ path: '/view-pickup/:pickup_id/*' }, location.pathname) ||
    matchPath({ path: '/scan-pickup/:pickup_id/*' }, location.pathname);
const isScheduleActive =
  location.pathname === '/driver-schedule' ||
  matchPath({ path: '/driver-schedule/*' }, location.pathname);
  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 1024;
      setIsMobile(isNowMobile);
      setIsSidebarOpen(!isNowMobile);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const linkClass = "flex items-center gap-2 py-2 px-3 text-lg rounded-md font-semibold leading-8 transition-colors";
  const activeClass = "bg-yellow-400 text-black";
  const iconClass = "text-blue-600";

  return (
    <>
      {/* Header */}
      <header className={`fixed top-0 ${isMobile ? 'left-0' : 'left-64'} right-0 h-16 bg-white shadow z-40 px-4 flex items-center justify-between transition-all duration-300`}>
        <div className="flex items-center gap-4">
          {isMobile && (
            <button onClick={toggleSidebar} className="p-2 rounded hover:bg-gray-100">
              {isSidebarOpen ? <FiX size={22} /> : <FiMenu size={22} />}
            </button>
          )}
          <h1 className="text-lg font-semibold whitespace-nowrap">Welcome Driver!!</h1>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={handleLogout}
            className="p-2 rounded-full text-red-500 hover:text-red-700 hover:bg-gray-100"
            title="Logout"
          >
            <FiLogOut size={20} />
          </button>

        </div>
      </header>

      {/* Sidebar */}
      <aside className={`fixed top-0 left-0 w-64 h-screen z-50 bg-lime-300 bg-gradient-to-b from-lime-400 to-lime-100 text-green-900 shadow-lg transition-transform duration-300 ease-in-out ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} xl:translate-x-0`}>
        <div className="xl:hidden flex justify-end p-4">
          <button onClick={toggleSidebar} className="text-green-900 hover:text-black" title="Close Sidebar">
            <FiX size={28} />
          </button>
        </div>

        <div className="flex flex-col h-full">
          <div className="p-6 flex items-center space-x-2">
            <img src={logo} alt="FareFuel" className="w-40" />
          </div>

          <nav className="flex-1 px-4 space-y-2 text-[16px] font-medium">
            <NavLink to="/driver" onClick={handleMobileClose} className={({ isActive }) => `${linkClass} ${isActive ? activeClass : 'hover:bg-yellow-400'}`}>
              <MdAccountBox size={20} className={iconClass} /> My Account
            </NavLink>
            <NavLink to="/FuelWallet" onClick={handleMobileClose} className={({ isActive }) => `${linkClass} ${isActive ? activeClass : 'hover:bg-yellow-400'}`}>
              <BsFillFuelPumpFill className={iconClass} /> Fuel Credit wallet
            </NavLink>
            <NavLink to="/driverpendingfund" onClick={handleMobileClose} className={({ isActive }) => `${linkClass} ${isActive ? activeClass : 'hover:bg-yellow-400'}`}>
              <RiRefund2Fill className={iconClass} /> Pending Fund
            </NavLink>
            <NavLink
              to="/driverpickuphistory"
              onClick={handleMobileClose}
              className={`${linkClass} ${isPickupHistoryActive ? activeClass : 'hover:bg-yellow-400'}`}
            >
              <FaHistory className={iconClass} /> Pickup History
            </NavLink>
            <NavLink
  to="/driver-schedule"
  onClick={handleMobileClose}
  className={`${linkClass} ${isScheduleActive ? activeClass : 'hover:bg-yellow-400'}`}
>
  <MdCalendarToday className={iconClass} /> My Schedule
</NavLink>
            <NavLink to="/driverpaymenthistory" onClick={handleMobileClose} className={({ isActive }) => `${linkClass} ${isActive ? activeClass : 'hover:bg-yellow-400'}`}>
              <MdPayments className={iconClass} /> Payment History
            </NavLink>
            <NavLink to="/PaymentSettings" onClick={handleMobileClose} className={({ isActive }) => `${linkClass} ${isActive ? activeClass : 'hover:bg-yellow-400'}`}>
              <TbSettingsDollar className={iconClass} /> Payment Settings
            </NavLink>
          </nav>
        </div>
      </aside>

      {/* Overlay */}
      {isMobile && isSidebarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-40 z-40" onClick={toggleSidebar}></div>
      )}
    </>
  );
};

export default TopBarWithSidebar;
